
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';

const GHOST_SVG_URL = "https://raw.githubusercontent.com/ghost-protocol-labs/ghost-token-sui/refs/heads/main/assets/GHOST.svg";

export const GhostBrandIcon = ({ className }: { className?: string }) => (
    <img 
        src={GHOST_SVG_URL} 
        alt="Ghost Protocol" 
        className={`${className} object-contain`}
        style={{ filter: 'drop-shadow(0 0 4px rgba(197, 160, 89, 0.2))' }}
    />
);

export const SolanaPartnerIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className={className}>
        <path fill="url(#SOL__a)" d="M18.413 7.903a.62.62 0 0 1-.411.164H3.58c-.512 0-.77-.585-.416-.929l2.368-2.283a.6.6 0 0 1 .41-.169h14.479c.517 0 .77.59.41.934z"/>
        <path fill="url(#SOL__b)" d="M18.413 19.157a.6.6 0 0 1-.411.157H3.58c-.512 0-.77-.58-.416-.923l2.368-2.289a.6.6 0 0 1 .41-.163h14.479c.517 0 .77.585.41.928z"/>
        <path fill="url(#SOL__c)" d="M18.413 10.472a.6.6 0 0 0-.411-.158H3.58c-.512 0-.77.58-.416-.922l2.368 2.29a.62.62 0 0 0 .41.163h14.479c.517 0 .77-.585.41-.928z"/>
        <defs>
            <linearGradient id="SOL__a" x1="3.001" x2="21.431" y1="16.322" y2="15.591" gradientUnits="userSpaceOnUse">
                <stop stopColor="#599DB0"/>
                <stop offset="1" stopColor="#47F8C3"/>
            </linearGradient>
            <linearGradient id="SOL__b" x1="3.001" x2="21.323" y1="16.973" y2="16.366" gradientUnits="userSpaceOnUse">
                <stop stopColor="#C44FE2"/>
                <stop offset="1" stopColor="#73B0D0"/>
            </linearGradient>
            <linearGradient id="SOL__c" x1="4.035" x2="20.302" y1="12.002" y2="12.002" gradientUnits="userSpaceOnUse">
                <stop stopColor="#778CBF"/>
                <stop offset="1" stopColor="#5DCDC9"/>
            </linearGradient>
        </defs>
    </svg>
);

export const SuiPartnerIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
        <circle cx="12" cy="12" r="12" fill="#4BA2FF" />
        <path fill="white" d="M16.129 10.508a5.44 5.44 0 0 1 1.148 3.356 5.47 5.47 0 0 1-1.18 3.399l-.064.079-.015-.106a5 5 0 0 0-.053-.26c-.37-1.656-1.567-3.08-3.547-4.234-1.334-.773-2.102-1.705-2.303-2.763a4.1 4.1 0 0 1 .159-1.97c.15-.494.385-.96.694-1.376l.773-.963a.333.333 0 0 1 .518 0zm1.217-.963L12.19 3.092a.243.243 0 0 0-.38 0L6.652 9.55l-.016.016a7.1 7.1 0 0 0-1.519 4.404C5.118 17.85 8.2 21 12 21s6.881-3.15 6.881-7.03a7.1 7.1 0 0 0-1.519-4.404zm-9.46.942.461-.577.016.106.037.254c.302 1.604 1.366 2.938 3.15 3.97 1.55.905 2.45 1.943 2.71 3.081.106.476.127.942.08 1.35v.026l-.022.01c-.72.36-1.513.547-2.318.546-2.912 0-5.278-2.414-5.278-5.389 0-1.275.434-2.45 1.165-3.377"/>
    </svg>
);

export const CetusPartnerIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className={className}>
        <path fill="#68FFD8" d="M20.438 11.438c0 4.54-3.78 8.005-8.438 8.005q-.66-.002-1.294-.096c-1.76 1.587-4.736 1.71-6.086 1.637l1.26-4.106a8.08 8.08 0 0 1-2.318-5.648C3.562 6.679 7.342 3 12 3c4.106 0 7.521 2.852 8.28 6.632-.933-.13-2.148-.529-2.475-1.496-.253.562-1.203 1.62-3.077 1.57a3 3 0 0 0 .433-1.57A3.12 3.12 0 0 0 12 5.053a3.12 3.12 0 0 0-3.167 3.083c.006 1.704 1.423 3.302 3.167 3.302z"/>
        <path fill="#00D49E" d="M17.592 11.437c-.98 4.691-5.232 8.004-10.34 8.004q-1.078 0-2.098-.202l-.54 1.744c1.356.073 4.332-.057 6.087-1.637q.64.094 1.3.095c4.657 0 8.437-3.465 8.437-8.004zm.208-3.303c.017-.028-.011.034 0 0 .332.968 1.547 1.367 2.475 1.497a8.23 8.23 0 0 0-3.735-5.344c.663 1.192 1.125 2.435 1.26 3.847"/>
    </svg>
);

export const JupiterPartnerIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className={className}>
        <path fill="url(#JUP__a)" d="M4.723 16.919a9.05 9.05 0 0 0 2.837 2.478 9.4 9.4 0 0 0 3.64 1.143c-.66-.957-1.62-1.837-2.82-2.507-1.198-.67-2.468-1.037-3.658-1.115"/>
        <path fill="url(#JUP__b)" d="M9.993 15.365c-2.31-1.292-4.81-1.62-6.598-1.04q.259.827.68 1.589c1.554-.035 3.25.371 4.83 1.254 1.578.883 2.786 2.1 3.525 3.418a9.6 9.6 0 0 0 1.771-.218c-.361-1.784-1.899-3.711-4.208-5.003"/>
        <path fill="url(#JUP__c)" d="M21 10.122a8.7 8.7 0 0 0-1.562-3.178 9.05 9.05 0 0 0-2.73-2.337 9.4 9.4 0 0 0-3.46-1.125 9.5 9.5 0 0 0-3.643.268c1.976.233 4.17.947 6.322 2.15S19.811 8.584 21 10.122"/>
        <path fill="url(#JUP__d)" d="M18.124 14.337c-1.011-1.617-2.744-3.166-4.88-4.36-2.134-1.193-4.39-1.875-6.35-1.92-1.723-.04-3.016.443-3.547 1.323l-.01.015q-.072.247-.127.496c.741-.281 1.6-.438 2.556-.456 2.124-.038 4.5.616 6.695 1.842 2.193 1.227 3.962 2.892 4.98 4.686.455.808.74 1.604.853 2.365q.196-.17.385-.351l.008-.017c.531-.881.326-2.201-.563-3.623"/>
        <path fill="url(#JUP__e)" d="M11.62 12.67c-3.27-1.83-6.883-2.116-8.62-.84q.005.6.095 1.194a7.5 7.5 0 0 1 1.57-.28c1.942-.14 4.082.38 6.025 1.467 1.942 1.086 3.473 2.619 4.308 4.31.231.464.407.951.525 1.452a9 9 0 0 0 1.125-.511c.29-2.085-1.758-4.964-5.028-6.793"/>
        <path fill="url(#JUP__f)" d="M19.805 11.63c-1.023-1.615-2.771-3.168-4.922-4.37s-4.414-1.894-6.38-1.95c-1.498-.041-2.658.308-3.26.969 2.499-.408 5.794.277 8.988 2.063s5.446 4.203 6.315 6.493c.298-.83.038-1.973-.741-3.205"/>
        <defs>
            <linearGradient id="JUP__a" x1="31.514" x2="-11.852" y1="-44.073" y2="1.318" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#C7F284"/>
                <stop offset="1" stopColor="#00BEF0"/>
            </linearGradient>
            <linearGradient id="JUP__b" x1="22.308" x2="-1.561" y1="-15.359" y2="11.673" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#C7F284"/>
                <stop offset="1" stopColor="#00BEF0"/>
            </linearGradient>
            <linearGradient id="JUP__c" x1="11.502" x2="-11.828" y1="12.343" y2="38.055" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#C7F284"/>
                <stop offset="1" stopColor="#00BEF0"/>
            </linearGradient>
            <linearGradient id="JUP__d" x1="16.445" x2="1.436" y1="1.484" y2="19.792" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#C7F284"/>
                <stop offset="1" stopColor="#00BEF0"/>
            </linearGradient>
            <linearGradient id="JUP__e" x1="18.777" x2="1.508" y1="-4.563" y2="16.538" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#C7F284"/>
                <stop offset="1" stopColor="#00BEF0"/>
            </linearGradient>
            <linearGradient id="JUP__f" x1="14.986" x2="7.18" y1="6.9" y2="20.843" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#C7F284"/>
                <stop offset="1" stopColor="#00BEF0"/>
            </linearGradient>
        </defs>
    </svg>
);

export const PythPartnerIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className={className}>
        <path fill="#110F24" d="M13.543 10.2c0 .993-.853 1.543-1.543 1.543V13.8a3.6 3.6 0 1 0-3.6-3.6v8.846L10.457 21V10.2c0-.668.55-1.542 1.543-1.542a1.543 1.543 0 0 1 1.543 1.543"/>
        <path fill="#110F24" d="M12 3a7.16 7.16 0 0 0-5.4 2.438A7.17 7.17 0 0 0 4.8 10.2v5.4l2.057 1.98V10.2c0-2.685 2.16-5.143 5.143-5.143s5.143 2.484 5.143 5.143c0 2.983-2.458 5.143-5.143 5.143V17.4A7.2 7.2 0 1 0 12 3"/>
    </svg>
);

export const PhantomPartnerIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className={className}>
        <path fill="#AB9FF2" d="M5.13 19.2c2.297 0 4.023-1.92 5.053-3.436a2.9 2.9 0 0 0-.195.994c0 .885.53 1.516 1.574 1.516 1.433 0 2.965-1.208 3.758-2.51a2 2 0 0 0-.083.524c0 .617.362 1.006 1.1 1.006 2.324 0 4.663-3.959 4.663-7.421C21 7.175 19.58 4.8 16.016 4.8 9.752 4.8 3 12.154 3 16.905 3 18.771 4.044 19.2 5.13 19.2m8.729-9.622c0-.671.39-1.141.96-1.141.557 0 .947.47.947 1.14 0 .672-.39 1.155-.947 1.155-.57 0-.96-.483-.96-1.154m2.979 0c0-.671.39-1.141.96-1.141.557 0 .947.47.947 1.14 0 .672-.39 1.155-.947 1.155-.57 0-.96-.483-.96-1.154"/>
    </svg>
);

export const HeliusPartnerIcon = ({ className }: { className?: string }) => (
    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path fill="#F15A24" d="M50 0l11.5 31.6H38.5L50 0zM100 50l-31.6 11.5V38.5L100 50zM50 100l-11.5-31.6h23L50 100zM0 50l31.6-11.5v23L0 50z" />
        <path fill="#F15A24" d="M85.4 14.6L63.5 35.4c-1.1-1.1-1.1-2.9 0-4l21.9-16.8zM85.4 85.4L64.6 63.5c1.1-1.1 2.9-1.1 4 0l16.8 21.9zM14.6 85.4l21.9-16.8c1.1 1.1 1.1 2.9 0 4L14.6 85.4zM14.6 14.6l20.8 21.9c-1.1 1.1-2.9 1.1-4 0L14.6 14.6z" />
        <circle cx="50" cy="50" r="18" fill="#F15A24" />
    </svg>
);

export const BirdeyePartnerIcon = ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9c.83 0 1.5-.67 1.5-1.5S7.83 8 7 8s-1.5.67-1.5 1.5S6.17 11 7 11zm10 0c.83 0 1.5-.67 1.5-1.5S17.83 8 17 8s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM12 17c2.03 0 3.8-1.11 4.75-2.75-.15-.25-.33-.48-.52-.69-.98 1.35-2.58 2.24-4.38 2.19-1.63-.04-3.08-1.03-3.83-2.46-.22.18-.46.34-.71.49C8.36 15.77 10.07 17 12 17z" fill="currentColor"/>
    </svg>
);

export const LayerZeroPartnerIcon = ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <circle cx="12" cy="12" r="12" fill="#000000" />
        <path d="M16.5 7.5L7.5 16.5M7.5 7.5L16.5 16.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="12" cy="12" r="5" stroke="white" strokeWidth="2.5" />
    </svg>
);
